import React from 'react';
import { Helmet } from 'react-helmet-async';

const TourStructuredData: React.FC<{tour: {
  name: string;
  description: string;
  image: string;
  url: string;
  price: string;
  location: string;
}}>
= ({ tour }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": tour.name,
    "description": tour.description,
    "image": tour.image,
    "url": tour.url,
    "offers": {
      "@type": "Offer",
      "price": tour.price,
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "location": {
      "@type": "Place",
      "name": tour.location,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "New York",
        "addressRegion": "NY",
        "addressCountry": "US"
      }
    }
  };
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default TourStructuredData;
